import { AbstractParser } from "../../parser";
import { LifeCycleConfiguration } from "src/app/ui/models/domains/pbm/Benefit/life-cycle-configuration";

export class LifeCycleConfigurationParser extends AbstractParser<LifeCycleConfiguration> {
  parse(payload: any): LifeCycleConfiguration {
    const lifeCycleConfiguration = new LifeCycleConfiguration();
    lifeCycleConfiguration.setKey(payload.Key);
    lifeCycleConfiguration.setCompanyFiscalNumber(payload.CompanyFiscalNumber);
    lifeCycleConfiguration.setStartDate(payload.StartDate);
    lifeCycleConfiguration.setEndDate(payload.EndDate);
    lifeCycleConfiguration.setClosedDay(payload.ClosedDay);
    lifeCycleConfiguration.setCloseDay2(payload.ClosedDay2)
    return lifeCycleConfiguration;
  }
}
